<template>
  <sidesheet :active="active" :title="title" @close="onClose" class="positions">
    <loader v-if="loading" class="loader mt-3" :active="loading" height="400" />

    <div v-else>
      <div class="d-none d-md-block">
        <table class="intervals-table">
          <thead>
            <tr>
              <th>Интервал</th>
              <th>Сотрудники</th>
              <th>Заказов обработано</th>
              <th>Нагрузка, ฿</th>
              <th>Норматив выработки, ฿</th>
              <th>Сумма штрафов/премий</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="interval in intervals">
              <tr :key="interval.id + '-total'" class="interval-header">
                <td class="text-nowrap">
                  {{ interval.interval }}
                </td>
                <td>{{ interval.employees.length }}</td>
                <td align="right">
                  {{ getNumber(interval.total.ordersCount) }}
                </td>
                <td align="right">{{ getNumber(interval.total.load) }}</td>
                <td align="right">
                  {{ getNumber(interval.total.revenueStandart) }}
                </td>
                <td align="right">
                  <span
                    :class="{
                      'positive-number': interval.total.finesAndBonuses > 0,
                      'negative-number': interval.total.finesAndBonuses < 0,
                    }"
                  >
                    {{ getNumber(interval.total.finesAndBonuses) }}
                  </span>
                </td>
              </tr>
              <tr v-for="employee in interval.employees" :key="interval.id + '-' + employee.id">
                <td></td>
                <td>{{ employee.name }}</td>
                <td align="right">{{ getNumber(employee.ordersCount) }}</td>
                <td align="right">{{ getNumber(employee.load) }}</td>
                <td align="right">{{ getNumber(employee.revenueStandart) }}</td>
                <td align="right">
                  <span
                    :class="{
                      'positive-number': employee.finesAndBonuses > 0,
                      'negative-number': employee.finesAndBonuses < 0,
                    }"
                  >
                    {{ getNumber(employee.finesAndBonuses) }}
                  </span>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <div class="d-md-none table-container">
        <htable>
          <table>
            <tr>
              <th>Интервал</th>
              <td
                v-for="interval in intervals"
                :key="interval.id"
                class="interval-header"
                :colspan="interval.employees.length + 1"
              >
                {{ interval.interval }}
              </td>
            </tr>
            <tr>
              <th>Сотрудники</th>
              <template v-for="interval in intervals">
                <td :key="interval.id + '-employees'" class="interval-header" align="right">
                  {{ interval.employees.length }}
                </td>
                <td
                  v-for="employee in interval.employees"
                  :key="interval.id + '-employees-' + employee.id"
                  align="right"
                >
                  {{ employee.name }}
                </td>
              </template>
            </tr>
            <tr>
              <th>Заказов<br />обработано</th>
              <template v-for="interval in intervals">
                <td :key="interval.id + '-orders'" class="interval-header" align="right">
                  {{ getNumber(interval.total.ordersCount) }}
                </td>
                <td v-for="employee in interval.employees" :key="interval.id + '-orders-' + employee.id" align="right">
                  {{ getNumber(employee.ordersCount) }}
                </td>
              </template>
            </tr>
            <tr>
              <th>Нагрузка, ฿</th>
              <template v-for="interval in intervals">
                <td :key="interval.id + '-load'" class="interval-header" align="right">
                  {{ getNumber(interval.total.load) }}
                </td>
                <td v-for="employee in interval.employees" :key="interval.id + '-load-' + employee.id" align="right">
                  {{ getNumber(employee.load) }}
                </td>
              </template>
            </tr>
            <tr>
              <th>Норматив<br />выр-ки, ฿</th>
              <template v-for="interval in intervals">
                <td :key="interval.id + '-revenueStandart'" class="interval-header" align="right">
                  {{ getNumber(interval.total.revenueStandart) }}
                </td>
                <td
                  v-for="employee in interval.employees"
                  :key="interval.id + '-revenueStandart-' + employee.id"
                  align="right"
                >
                  {{ getNumber(employee.revenueStandart) }}
                </td>
              </template>
            </tr>
            <tr>
              <th>Сумма<br />штрафов/<br />премий</th>
              <template v-for="interval in intervals">
                <td :key="interval.id + '-finesAndBonuses'" class="interval-header" align="right">
                  <span
                    :class="{
                      'negative-number': interval.total.finesAndBonuses < 0,
                      'positive-number': interval.total.finesAndBonuses > 0,
                    }"
                  >
                    {{ getNumber(interval.total.finesAndBonuses) }}
                  </span>
                </td>
                <td
                  v-for="employee in interval.employees"
                  :key="interval.id + '-finesAndBonuses-' + employee.id"
                  align="right"
                >
                  <span
                    :class="{
                      'negative-number': employee.finesAndBonuses < 0,
                      'positive-number': employee.finesAndBonuses > 0,
                    }"
                  >
                    {{ getNumber(employee.finesAndBonuses) }}
                  </span>
                </td>
              </template>
            </tr>
          </table>
        </htable>
      </div>
    </div>
  </sidesheet>
</template>

<script>
import Sidesheet from "@/components/sidesheet";
import Loader from "@/components/loader";
import HorizontalTable from "@/components/horizontal-table";

export default {
  name: "position-intervals-sidesheet",

  components: {
    sidesheet: Sidesheet,
    loader: Loader,
    htable: HorizontalTable,
  },

  data() {
    return {
      active: false,
      loading: false,
      title: "",
      intervals: [],
    };
  },

  methods: {
    open(position, intervals) {
      this.title = position.groupName;


      this.loading = true;
      this.loadIntervals(position.code).then((data) => {
        console.log(data.intervals);
        this.intervals = data.intervals;
        console.log(intervals);
        this.intervals = [];
        intervals.forEach((i, id)=>{
          var interval = {
            "id": id,
            "interval": i.start + " – " + i.finish,
            "employees": [],
            "total": {
              "ordersCount": i.orders,
              "load": Math.round(i.sum),
              "revenueStandart": Math.round(i.norm),
              "finesAndBonuses": i.sum_bonus_calc > 0 ? Math.round(i.sum_bonus_calc) : (i.sum_penalty_calc < 0 ? Math.round(i.sum_penalty_calc) : 0),
            }
          };
          for(var id2 in i.workers) {
            var w = i.workers[id2];
            interval.employees.push({
              "finesAndBonuses": null,
              "id": id * 100 + id2,
              "revenueStandart": Math.round(w.norm),
              "name": w.showname,
              "ordersCount": null,
              "load": null,
            })
          }
          this.intervals.push(interval)
        })

        this.loading = false;
      });

      this.active = true;
    },
    onClose() {
      this.active = false;
    },
    loadIntervals(code) {
      return this.$store.dispatch("calculations/getPositionIntervals", {
        positionCode: code,
      });
    },
    getNumber(num) {
      if (num == null) return "—";
      return num.toLocaleString();
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/styles/vars";
.positions .sidesheet__content {
  overflow-y: auto;
}
.intervals-table {
  border-collapse: collapse;
  font-size: 13px;
  width: 100%;
  max-width: 860px;
  margin-top: 28px;

  td,
  th {
    padding: 10px;
    border: 1px solid $color-border-light;
  }

  th {
    border-bottom-width: 2px;
    color: $color-label;
    font-size: 12px;
    font-weight: 500;
  }

  .interval-header {
    td {
      background: $color-bg;
    }
  }
}

.table-container {
  margin-left: -20px;
  margin-right: -20px;
  margin-top: 26px;

  .interval-header {
    background: $color-bg;
  }
}
</style>
